/* NESTROVE Shopify Theme JS */
(function () {
  "use strict";

  /* Announcement bar rotation */
  document.querySelectorAll("[data-announcement]").forEach(function (bar) {
    var msgs = bar.querySelectorAll(".n-announce__msg");
    if (msgs.length < 2) return;
    var i = 0;
    setInterval(function () {
      msgs[i].classList.remove("is-active");
      i = (i + 1) % msgs.length;
      msgs[i].classList.add("is-active");
    }, 3500);
  });

  /* Smooth-scroll anchors */
  document.querySelectorAll('a[data-scroll]').forEach(function (link) {
    link.addEventListener("click", function (e) {
      var id = link.getAttribute("href").split("#")[1];
      var el = document.getElementById(id);
      if (el) {
        e.preventDefault();
        el.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    });
  });

  /* Back to top */
  var backTop = document.getElementById("BackToTop");
  if (backTop) {
    var onScroll = function () {
      backTop.classList.toggle("is-visible", window.scrollY > 600);
    };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    backTop.addEventListener("click", function () {
      window.scrollTo({ top: 0, behavior: "smooth" });
    });
  }

  /* Product gallery */
  document.querySelectorAll("[data-gallery]").forEach(function (gallery) {
    var mainImg = gallery.querySelector("[data-main-image]");
    var mainVideo = gallery.querySelector("[data-main-video]");
    gallery.querySelectorAll("[data-thumb]").forEach(function (thumb) {
      thumb.addEventListener("click", function () {
        gallery.querySelectorAll("[data-thumb]").forEach(function (t) { t.classList.remove("is-active"); });
        thumb.classList.add("is-active");
        var video = thumb.getAttribute("data-video");
        if (video && mainVideo) {
          mainVideo.src = video;
          mainVideo.hidden = false;
          if (mainImg) mainImg.hidden = true;
        } else {
          if (mainVideo) { mainVideo.hidden = true; mainVideo.pause && mainVideo.pause(); }
          if (mainImg) {
            mainImg.hidden = false;
            mainImg.src = thumb.getAttribute("data-image");
          }
        }
      });
    });
  });

  /* Quantity steppers */
  document.addEventListener("click", function (e) {
    var btn = e.target.closest("[data-qty-btn]");
    if (!btn) return;
    var wrap = btn.closest(".n-qty");
    var input = wrap.querySelector("input");
    var display = wrap.querySelector("span");
    var val = parseInt(input ? input.value : display.textContent, 10) || 1;
    val = Math.max(1, val + parseInt(btn.getAttribute("data-qty-btn"), 10));
    if (input) input.value = val;
    if (display) display.textContent = val;
  });

  /* FAQ accordion */
  document.querySelectorAll(".n-faq__item").forEach(function (item) {
    var q = item.querySelector(".n-faq__q");
    q.addEventListener("click", function () {
      var open = item.classList.contains("is-open");
      item.closest("[data-faq]").querySelectorAll(".n-faq__item").forEach(function (i) {
        i.classList.remove("is-open");
      });
      if (!open) item.classList.add("is-open");
    });
  });

  /* Reviews pagination */
  document.querySelectorAll("[data-reviews]").forEach(function (section) {
    var cards = Array.prototype.slice.call(section.querySelectorAll(".n-review-card"));
    var perPage = 6;
    var pages = Math.ceil(cards.length / perPage);
    var dotsWrap = section.querySelector(".n-reviews__dots");
    var grid = section.querySelector(".n-reviews__grid");
    if (pages < 2 || !dotsWrap) return;
    var current = 0;
    var render = function () {
      cards.forEach(function (c, idx) {
        c.style.display = idx >= current * perPage && idx < (current + 1) * perPage ? "" : "none";
      });
      dotsWrap.querySelectorAll(".n-reviews__dot").forEach(function (d, idx) {
        d.classList.toggle("is-active", idx === current);
      });
      grid.classList.remove("is-fading");
      void grid.offsetWidth;
      grid.classList.add("is-fading");
    };
    for (var p = 0; p < pages; p++) {
      var dot = document.createElement("button");
      dot.className = "n-reviews__dot" + (p === 0 ? " is-active" : "");
      dot.setAttribute("aria-label", "Reviews page " + (p + 1));
      dot.setAttribute("data-page", p);
      dot.addEventListener("click", function () {
        current = parseInt(this.getAttribute("data-page"), 10);
        render();
      });
      dotsWrap.appendChild(dot);
    }
    render();
  });

  /* Video modal */
  var modal = document.getElementById("VideoModal");
  var player = document.getElementById("VideoModalPlayer");
  document.querySelectorAll("[data-video-open]").forEach(function (btn) {
    btn.addEventListener("click", function () {
      if (!modal || !player) return;
      player.src = btn.getAttribute("data-video-open");
      modal.hidden = false;
      player.play().catch(function () {});
    });
  });
  if (modal) {
    modal.addEventListener("click", function (e) {
      if (e.target === modal || e.target.closest("[data-video-close]")) {
        modal.hidden = true;
        player.pause();
        player.src = "";
      }
    });
  }

  /* Cart drawer */
  var openCart = function () { document.body.classList.add("cart-open"); };
  var closeCart = function () { document.body.classList.remove("cart-open"); };
  document.querySelectorAll("[data-cart-open]").forEach(function (btn) {
    btn.addEventListener("click", function (e) {
      e.preventDefault();
      openCart();
    });
  });
  document.addEventListener("click", function (e) {
    if (e.target.closest("[data-cart-close]") || e.target.id === "CartOverlay") closeCart();
  });

  var refreshCartDrawer = function () {
    fetch(window.location.pathname + "?sections=cart-drawer-section")
      .then(function (r) { return r.json(); })
      .catch(function () { return null; })
      .finally(function () { window.location.reload && null; });
  };

  /* AJAX add to cart */
  document.querySelectorAll('form[action*="/cart/add"]').forEach(function (form) {
    form.addEventListener("submit", function (e) {
      e.preventDefault();
      var btn = form.querySelector('[type="submit"]');
      if (btn) btn.disabled = true;
      fetch("/cart/add.js", {
        method: "POST",
        body: new FormData(form),
      })
        .then(function (r) { return r.json(); })
        .then(function () {
          return fetch("/cart.js").then(function (r) { return r.json(); });
        })
        .then(function (cart) {
          var count = document.getElementById("CartCount");
          if (count) count.textContent = cart.item_count;
          window.location.href = window.location.pathname + "#";
          window.location.reload();
        })
        .catch(function () { window.location.reload(); })
        .finally(function () { if (btn) btn.disabled = false; });
    });
  });

  /* Cart drawer quantity buttons */
  document.addEventListener("click", function (e) {
    var btn = e.target.closest("[data-cart-qty]");
    if (!btn) return;
    var line = parseInt(btn.getAttribute("data-cart-qty"), 10);
    var dir = parseInt(btn.getAttribute("data-dir"), 10);
    var span = btn.parentElement.querySelector("span");
    var qty = Math.max(0, (parseInt(span.textContent, 10) || 1) + dir);
    fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ line: line, quantity: qty }),
    })
      .then(function (r) { return r.json(); })
      .then(function () { window.location.reload(); })
      .catch(function () { window.location.reload(); });
  });
})();
